

















































import { Component, Prop, Vue } from "vue-property-decorator";
import { ReservationModel } from "./types";

@Component
export default class ReservationFormInfo extends Vue {
  @Prop({ default: null }) reservation?: ReservationModel;

  get numberOfGuests() {
    return this.reservation
      ? (this.reservation.numberOfAdults ?? 0) +
          (this.reservation.numberOfChildren ?? 0)
      : 0;
  }

  get numberOfSelectedUnits() {
    if (this.reservation) {
      return this.reservation.accomodationUnitTypes.length || 0;
    }
    return 0;
  }
  get numberOfSituatedGuests() {
    let numberOfGuests = 0;
    if (this.reservation) {
      for (const unit of this.reservation.accomodationUnitTypes) {
        numberOfGuests += unit.numberOfAdults || 0;
        numberOfGuests += unit.numberOfChildren || 0;
      }
    }

    return numberOfGuests;
  }

  get availableOccupancy() {
    let availableOccupancy = 0;

    if (this.reservation) {
      for (const unit of this.reservation.accomodationUnitTypes) {
        availableOccupancy += unit.allowedOccupancy;
      }
    }

    return availableOccupancy;
  }
}
